export default () => {
    const initializeTabs = () => {
        const tabItem = document.querySelectorAll(".tab-item");
        const closeTabs = document.querySelectorAll(".product-detail-tabs__close");
        const productsTabContent = document.querySelector(".product-detail-tabs");

        if (!document.querySelector(".product-detail-tabs")) {
            tabItem[0].classList.add("active");
            document.querySelectorAll(".tab-content")[0].classList.add("is-active");
        }

        tabItem.forEach((item) => {
            item.addEventListener("click", (e) => {
                closeTabs.forEach((btn) => {
                    btn.style.display = "block";
                });
                tabItem.forEach((tab) => {
                    tab.classList.remove("active");
                });
                item.classList.add("active");

                let id = item.getAttribute("data-tab-content");
                let tabContent = document.getElementById(id);
                document.querySelectorAll(".tab-content").forEach((item) => {
                    item.classList.remove("is-active");
                });
                tabContent.classList.add("is-active");
                if (productsTabContent) {
                    productsTabContent.style.backgroundColor = "#efece2";
                    productsTabContent.style.maxWidth = "440px";
                }
                if (window.innerWidth <= 639) {
                    productsTabContent.style.maxWidth = "355px";
                    
                }
                
            });

            closeTabs.forEach((btn) => {
                btn.addEventListener("click", () => {
                productsTabContent.style.backgroundColor = "unset";
                productsTabContent.style.maxWidth = "173px";
                if (window.innerWidth <= 1023) {
                    productsTabContent.style.maxWidth = "30px";
                   
                }
                document.querySelectorAll(".tab-content").forEach((item) => {
                    item.classList.remove("is-active");
                });
                tabItem.forEach((tab) => {
                    tab.classList.remove("active");
                });
                btn.style.display = "none";
                });
            });
        });
    };

    if (document.querySelectorAll(".tab-item").length) {
        initializeTabs();
    }
};
